export function buildAnomalyUrl ({
  companyId,
  siteId,
  assetId
}) {
  if (siteId && assetId) {
    return `/company/${companyId}/sites/${siteId}/assets/${assetId}/anomalies`
  }
  if (siteId) {
    return `/company/${companyId}/sites/${siteId}/anomalies`
  }
  return `/company/${companyId}/anomalies`
}
